import { render, staticRenderFns } from "./AwardList.vue?vue&type=template&id=4411f13d&scoped=true"
import script from "./AwardList.vue?vue&type=script&lang=js"
export * from "./AwardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4411f13d",
  null
  
)

export default component.exports